import React from 'react';
import { Menu, X } from 'lucide-react';

const Navigation = () => {
  const [isOpen, setIsOpen] = React.useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false);
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-brand-dark/95 backdrop-blur-sm border-b border-brand-magenta/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          
          {/* LOGO ALANI */}
          <div className="flex-shrink-0">
            <a 
              href="/" 
              onClick={(e) => {
                if (window.location.pathname === '/') {
                  window.location.reload();
                }
              }} 
              className="flex items-center gap-3 group cursor-pointer"
            >
              {/* public klasöründeki logo.png dosyanı çeker */}
              <img 
                src="/logo.png" 
                alt="Logo" 
                className="h-10 w-auto transition-transform duration-300 group-hover:scale-110"
                onError={(e) => e.target.style.display='none'} 
              />
              
              <div className="flex flex-col">
                <span className="text-xl font-bold tracking-tighter text-white leading-none">
                  VIRALVANTAGE
                </span>
                <span className="text-[10px] font-bold tracking-[0.3em] text-brand-magenta leading-none uppercase">
                  Media
                </span>
              </div>
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('portfolio')}
              className="text-white hover:text-brand-hot-pink transition-colors duration-200 font-medium"
            >
              Portfolio
            </button>
            <button
              onClick={() => scrollToSection('why-us')}
              className="text-white hover:text-brand-hot-pink transition-colors duration-200 font-medium"
            >
              Why Us
            </button>
            <button
              onClick={() => scrollToSection('pricing')}
              className="text-white hover:text-brand-hot-pink transition-colors duration-200 font-medium"
            >
              Pricing
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="text-white hover:text-brand-hot-pink transition-colors duration-200 font-medium"
            >
              FAQ
            </button>
            <button
              onClick={() => scrollToSection('free-audit')}
              className="bg-brand-magenta text-white px-6 py-3 rounded-full font-semibold hover:bg-opacity-80 transition-all"
            >
              Free Audit
            </button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-white hover:text-brand-hot-pink transition-colors"
            >
              {isOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <div className="md:hidden bg-brand-darker border-t border-brand-magenta/20">
          <div className="px-4 pt-4 pb-6 space-y-4">
            <button
              onClick={() => scrollToSection('portfolio')}
              className="block w-full text-left text-white hover:text-brand-hot-pink transition-colors duration-200 py-2 font-medium"
            >
              Portfolio
            </button>
            <button
              onClick={() => scrollToSection('why-us')}
              className="block w-full text-left text-white hover:text-brand-hot-pink transition-colors duration-200 py-2 font-medium"
            >
              Why Us
            </button>
            <button
              onClick={() => scrollToSection('pricing')}
              className="block w-full text-left text-white hover:text-brand-hot-pink transition-colors duration-200 py-2 font-medium"
            >
              Pricing
            </button>
            <button
              onClick={() => scrollToSection('faq')}
              className="block w-full text-left text-white hover:text-brand-hot-pink transition-colors duration-200 py-2 font-medium"
            >
              FAQ
            </button>
            <button
              onClick={() => scrollToSection('free-audit')}
              className="bg-brand-magenta text-white px-6 py-3 rounded-full font-semibold w-full text-center"
            >
              Free Audit
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation;